import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const SCListCont = styled.div((props) => ({
  marginTop:'1rem',
  // width:'80vw',

  '.ui.table':{
    borderWidth:0
  },

  '.ReactTable .rt-thead.-header':{
    boxShadow:'none',
    background: '#eaeff5'
  },

  '.ReactTable':{
    borderRadius:'0.5rem'
  },

  '.ReactTable .rt-thead .rt-th':{
    borderRight: 0
  },

  '.ReactTable .rt-tbody .rt-td':{
    borderRight: 0
  },

  '.-padRow':{
    cursor:'default !important'
  },

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

  '@media only screen and (min-width: 600px)': {
    // width: '100vw',
  },

  '@media only screen and (min-width: 769px)': {
    width: '80vw',
  },

}))

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))

export const CardButtonBody = styled.div((props) => ({
  display: 'flex',
  width: '200px',
  height: '60px',
  flexDirection: 'column',
  borderRadius: '5px',
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.1)',
  border: 'solid 1px #fbbf66',
  backgroundColor: '#ffffff',
  fontFamily: 'IBM Plex Sans Thai',
  background: '#FFFFFF',
  marginRight: '17px',
  marginBottom: '15px',
  ':hover': {
    border: 'solid 0px transparent',
    WebkitBackdropFilter: 'blur(30px)',
    backdropFilter: 'blur(30px)',
    boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
    backgroundImage: 'linear-gradient(243deg, #fdf095, #fbbf66, #fbbf66)'
  }
}))

export const BodyCardContent = styled.div((props) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'row'
}))

export const TitleContent = styled.div((props) => ({
  verticalAlign: 'top',
  width: '66.0130718954248%',
  paddingLeft: '15px',
  fontSize: '12px',
  fontWeight: 'bold',
  height: '100%',
  alignItems: 'center',
  display: 'flex',
  color: '#505050 !important'
}))

export const ValueContent = styled.div((props) => ({
  verticalAlign: 'top',
  width: '32.0261437908497%',
  display: 'flex',
  justifyContent: 'space-around',
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
  color: '#505050 !important',
  '.ValueText': {
    fontSize: '2.5rem',
    lineHeight: 1,
    color: '#fbbf66',
    ":hover": {
      color: '#ffffff'
    }
  }
}))